var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5956_861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7341 7.0413L1.83542 0.748629C1.71146 0.688225 1.57417 0.660354 1.43648 0.667639C1.29878 0.674924 1.1652 0.717127 1.04831 0.790274C0.931425 0.863421 0.835071 0.965107 0.768319 1.08576C0.701568 1.20642 0.666614 1.34207 0.666748 1.47996V1.5033C0.666814 1.6123 0.680248 1.72089 0.706748 1.82663L1.94408 6.77596C1.96067 6.8419 1.99702 6.90118 2.04826 6.94587C2.0995 6.99055 2.16317 7.0185 2.23075 7.02596L7.66875 7.63063C7.75923 7.64151 7.84258 7.68517 7.90305 7.75335C7.96352 7.82153 7.99691 7.9095 7.99691 8.00063C7.99691 8.09176 7.96352 8.17973 7.90305 8.24791C7.84258 8.31609 7.75923 8.35975 7.66875 8.37063L2.23075 8.9753C2.16317 8.98276 2.0995 9.01071 2.04826 9.0554C1.99702 9.10008 1.96067 9.15937 1.94408 9.2253L0.706748 14.174C0.680248 14.2797 0.666814 14.3883 0.666748 14.4973V14.5206C0.666727 14.6585 0.701763 14.794 0.768562 14.9146C0.83536 15.0352 0.931726 15.1368 1.0486 15.2098C1.16547 15.2829 1.299 15.325 1.43664 15.3323C1.57429 15.3396 1.71151 15.3117 1.83542 15.2513L14.7334 8.95863C14.913 8.871 15.0644 8.73466 15.1703 8.56517C15.2762 8.39567 15.3324 8.19983 15.3324 7.99996C15.3324 7.8001 15.2762 7.60426 15.1703 7.43476C15.0644 7.26526 14.9137 7.12893 14.7341 7.0413Z",
    fill: "#F37D53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5956_861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSendIcon);
export default __webpack_public_path__ + "static/media/message-send-icon.59dad0ec73eb2a191b9e5e7dab042d64.svg";
export { ForwardRef as ReactComponent };